<template>
  <v-container fluid>
    <v-layout justify-center lg12>
      <v-card width="100%" >
      <v-flex lg12 pa-5 >
        <v-layout>
          <h2 class="primary--text text-uppercase textoAjustado text-center" pa-3>
            {{localization.edit.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle"></v-divider>
        <v-form v-model="valid" id="valid" ref="form">
          <v-layout wrap align-center v-for="estado in estados" :key="estado.id">
            <v-flex xs3 pl-3 pr-3>
              <v-text-field 
                v-if="estado.translates[usuario.idioma] && estado.translates[usuario.idioma].length > 0"
                v-model="estado.translates[usuario.idioma]"
                id="estado"
                readonly
              />
              <v-text-field v-else
                v-model="estado.name"
                id="estado"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
              <v-text-field 
                v-model="estado.mensajeTraducido"
                id="mensaje"
                :label="localization.edit.mensaje"
                :rules="[rules.max(100)]"
                disabled
              />
            </v-flex>
            <v-icon
                class="iconSize"
                small
                @click="openTranslateDialog(estado.id)"
                >mdi-web</v-icon
              >
          </v-layout>
        </v-form>
        <!-- <v-layout class="pt-2">
          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <v-btn 
              color="primary"
              @click="guardar()"
            >
              {{localization.edit.guardar}}
            </v-btn>
          </v-flex>
        </v-layout> -->
        <TranslatePopUp
                ref="TranslatePopUp"
                :translateFlag="translateDialog"
                @cancel="translateDialog = false"
                @save="guardarTraduccion($event)"
                :idMaestro="idMaestro"
                :tipoMaestro="tipoMaestro"
              />
      </v-flex>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import TranslatePopUp from "../../custom/translatePopUp.vue";

export default {
  mixins: [rulesMixin],
  components: {
    TranslatePopUp
  },
  data () {
    return {
      valid: true,
      translateDialog: false,
      idMaestro: null,
      tipoMaestro: null
    }
  },
  computed: {
    ...mapGetters({
      getEstados: 'incidencias/getStatusTypes',
      getterMensajesEstados: 'incidencias/getMensajesEstados'
    }),
    translates() {
      if (this.$store.state.incidencias.translates) {
        return this.$store.state.incidencias.translates;
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    mensajesTipoEstado () {
      if (this.$store.state.incidencias.mensajesEstados) {
        return this.$store.state.incidencias.mensajesEstados
      }
      return []
    },
    localization () {
      return this.$t('maestros.mensajesTipoEstado')
    },
    estados () {
      return this.getEstados.map(x => {
        return {
          ...x,
          mensaje: this.getMensaje(x.code) ? this.getMensaje(x.code).mensajeTipo : null,
          mensajeTraducido: this.getMensajeTraducido(x.id)
        }
      })
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    ...mapActions({
      getStatusTypes: 'incidencias/getStatusTypes',
      getMensajesEstados: 'incidencias/getMensajesEstados',
      guardarMensajesEstados: 'incidencias/guardarMensajesEstados',
      addAlert: 'alerts/add',
      saveTranslates: "incidencias/updateTranslates"
    }),
    initialize () {
      this.getStatusTypes()
      this.getMensajesEstados()
    },
    async openTranslateDialog(id) {
      
      this.tipoMaestro = "mensajesTipoEstado";
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      this.loader.hide();
      this.$refs.TranslatePopUp.getTranslates()
      this.idMaestro = id;
      this.translateDialog = true;
    },
    async guardarTraduccion(traducciones) {
      let tipoMaestro = "mensajesTipoEstado";
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      await this.saveTranslates({
        idMaestro: this.idMaestro,
        tipoMaestro: tipoMaestro,
        traducciones: traducciones,
      });
      await this.getMensajesEstados()
      this.loader.hide();
      this.translateDialog = true;
    },
    async guardar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        const loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false
        })
        try {
          let values = this.estados.map(x => {
            return {
              estadoIncidenciaId: x.id,
              mensajeTipo: x.mensaje ? x.mensaje : null
            }
          })
          await this.guardarMensajesEstados(values)
          await this.initialize()
          loader.hide()
          this.addAlert({ texto: this.$t('datosModificados'), color: 'success' })
        } catch (error) {
          this.addAlert({ texto: this.$t('errorGuardarDatos') + error.message, color: 'error' })
          loader.hide()
        }
      }
    },
    getMensaje (code) {
      return this.getterMensajesEstados.find(y => y.codigo === code)
    },
    getTranslates (id) {
      return this.mensajesTipoEstado.find( y => y.estadoIncidenciaId === id)
    },
    getMensajeTraducido(id){
      if ( this.mensajesTipoEstado.length === 0) return null
      let mensaje = this.mensajesTipoEstado.find( y => y.estadoIncidenciaId === id)
      mensaje = mensaje ? mensaje : null
      let response = mensaje ? (mensaje.mensajeTipo || null) : null
      
      if ( mensaje !== null) {
        if(typeof mensaje.translates === "string"){
        let aux = JSON.parse(mensaje.translates)
          if(aux[this.usuario.idioma]){
            response =  aux[this.usuario.idioma]
          }
        } 

        if(mensaje.translates && mensaje.translates[this.usuario.idioma]){
          response = mensaje.translates[this.usuario.idioma]
        }
      }
      return response
    }
  }
}
</script>
